<body>
<div class="page-content newPadding getStartedBgpattern-5  px-0">
    <div class="container px-0 pt-4">
        <div class="heading-title mb-4">
            <h3 class="font-weight-bold mb-2">EMI Card</h3>
        </div>
        <div class="emi-card minus-margin">
            <div class="emi-card-body">
                <!-- <img src="./assets/img/emicard_background.png" alt="emi-card" class="img-fluid" /> -->
                <div class="emi-card">
                    <div class="emi-card-header mb-3">
                      <div class="align-items-center">
                        <div class="d-flex icon mr-2">
                              <img
                              src="./assets/img/emi-icon.svg"
                              alt="emi-card"
                              class="img-fluid"
                            />
                          <div class="text">
                            <h5 class="font-weight-bold mb-0 pl-2">EMI Card</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="emi-card-body">
                      <div class="container">
                          <a routerLink="/managecard">
                              <img
                              src="./assets/images/EMI_CARD_project.png"
                              style="width:100%" 
                            
                            />
                          </a>
                        <div class="cardInfo">
                            <div class="cardnumber">
                                {{ emiCardNumber }}
                            </div>
                            <div class="validupto">{{ emiCardValidUpto }}</div>
                            <div class="cardname">{{ emiCardName }}</div>
                          </div>
                      </div>
                    </div>
                  </div>
            </div>
        </div>
        <div class="cards-details getStartedBgpattern-5 extraSpaceAfterCards">
            <div class="emi-card-option ">
                <div class="heading-title">
                    <h3 class="font-weight-bold mb-3 pb-1 fs-18">Card Details</h3>
                </div>
                <div class="card mb-3 border-0 rounded-lg">
                    <div class="card-body p-2">
                        <div class="d-flex align-items-center position-relative">
                            <div class="icon mr-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="46" height="44" fill="none">
                                    <rect width="45.3174" height="44" fill="#108A43" rx="8" />
                                    <g stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                                        <path
                                            d="M28.6667 17v10A1.6666 1.6666 0 0 1 27 28.6667h-8.3333A1.6666 1.6666 0 0 1 17 27V17a1.6665 1.6665 0 0 1 1.6667-1.6667H27A1.6665 1.6665 0 0 1 28.6667 17ZM20.3333 25.3333h5" />
                                        <path
                                            d="M22.8333 22.8333c.9205 0 1.6667-.7462 1.6667-1.6666 0-.9205-.7462-1.6667-1.6667-1.6667-.9204 0-1.6666.7462-1.6666 1.6667 0 .9204.7462 1.6666 1.6666 1.6666ZM15.3333 18.6667h2.5M15.3333 22h2.5M15.3333 25.3333h2.5" />
                                    </g>
                                </svg>
                            </div>
                            <div class="name mr-auto">
                                <h3 class="font-weight-bold mb-0 h6">KYC Status</h3>
                            </div>
                            <div class="arrow">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
                                    <g opacity=".5">
                                        <path stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" d="m7.5 5 5 5-5 5" />
                                    </g>
                                </svg>
                            </div>
                            <a href="#" (click)="onKYCClick($event)" class="stretched-link"></a>
                        </div>

                    </div>
                </div>
                <div class="card mb-3 border-0 rounded-lg">
                    <div class="card-body p-2">
                        <div class="d-flex align-items-center position-relative">
                            <div class="icon mr-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="46" height="44" fill="none">
                                    <rect width="45.3174" height="44" fill="#108A43" rx="8" />
                                    <g stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                                        <path
                                            d="M27.8333 19.5H19.5c-.9205 0-1.6667.7462-1.6667 1.6667v5c0 .9204.7462 1.6666 1.6667 1.6666h8.3333c.9205 0 1.6667-.7462 1.6667-1.6666v-5c0-.9205-.7462-1.6667-1.6667-1.6667Z" />
                                        <path
                                            d="M23.6667 25.3333c.9204 0 1.6666-.7462 1.6666-1.6666 0-.9205-.7462-1.6667-1.6666-1.6667C22.7462 22 22 22.7462 22 23.6667c0 .9204.7462 1.6666 1.6667 1.6666ZM26.1667 19.5v-1.6667A1.6666 1.6666 0 0 0 24.5 16.1667h-8.3333A1.6666 1.6666 0 0 0 14.5 17.8333v5c0 .4421.1756.866.4882 1.1785a1.6663 1.6663 0 0 0 1.1785.4882h1.6666" />
                                    </g>
                                </svg>
                            </div>
                            <div class="name mr-auto">
                                <h3 class="font-weight-bold mb-0 h6">E-Mandate Status</h3>
                            </div>
                            <div class="arrow">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
                                    <g opacity=".5">
                                        <path stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" d="m7.5 5 5 5-5 5" />
                                    </g>
                                </svg>
                            </div>
                            <a href="#"(click)="onRepaymentStatus($event)" class="stretched-link"></a>
                        </div>

                    </div>
                </div>
                <div class="card mb-3 border-0 rounded-lg">
                    <div class="card-body p-2">
                        <div class="d-flex align-items-center position-relative">
                            <div class="icon mr-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="46" height="44" fill="none">
                                    <rect width="45.3174" height="44" fill="#108A43" rx="8" />
                                    <g stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                                        <path
                                            d="M21.8292 29.5h-5.6625c-.4421 0-.866-.1756-1.1785-.4882a1.6663 1.6663 0 0 1-.4882-1.1785v-10a1.6666 1.6666 0 0 1 1.6667-1.6666h10c.442 0 .8659.1756 1.1785.4881a1.667 1.667 0 0 1 .4881 1.1785v3.3334M27 23.6667V27h3.3333" />
                                        <path
                                            d="M27 30.3333c1.8409 0 3.3333-1.4924 3.3333-3.3333 0-1.841-1.4924-3.3333-3.3333-3.3333S23.6667 25.159 23.6667 27c0 1.8409 1.4924 3.3333 3.3333 3.3333ZM24.5 14.5v3.3333M17.8333 14.5v3.3333M14.5 21.1667h13.3333" />
                                    </g>
                                </svg>
                            </div>
                            <div class="name mr-auto">
                                <h3 class="font-weight-bold mb-0 h6">Valid Till</h3>
                            </div>
                            <div class="arrow">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
                                    <g opacity=".5">
                                        <path stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" d="m7.5 5 5 5-5 5" />
                                    </g>
                                </svg>
                            </div>
                            <a href="#" (click)="onDate($event)" class="stretched-link"></a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</body>